var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('single-select',{attrs:{"value":_vm.compValue,"value-property":'value',"options":_vm.options,"readonly":_vm.readonly},on:{"update:value":function($event){_vm.compValue=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }